<template>
  <div :class="{'scroll-table': scroll_table}">
    <table style="width: 100%;background: #fff;">
      <thead>
        <tr>
          <th v-for="th in ths">{{th.label}}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(data, index) in datas">
          <td :rowspan="(data[th.key] || {}).rowspan || 1" v-for="th in ths" :class="{'s-bak-td': rowDef && !(data[th.key] || {}).label && (index % 3 === 1)}"  :style="th.style ? th.style(data[th.key]) : {}" v-if="(data[th.key] || {}).rowspan !== 0">{{(data[th.key] || {}).label || data[th.key]}}</td>
        </tr>
      </tbody>
    </table>
    <div class="t-tfoot" v-if="page_parm">
      <el-pagination small layout="prev, pager, next" v-on:current-change="pageChange" :page-size="page_parm.row_num" :total="page_parm.dataTotal">
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  props: ['datas', 'ths', 'page_parm', 'rowDef', 'scroll_table'],
  methods: {
    pageChange (page) {
      this.$emit('pageChange', page)
    }
  }
}
</script>

<style scoped lang="less">
@import '../style/base.less';
.jj-bak-td {
    background-color: @bak-color-2;
    color: #00ccff;
  }
  .ps-bak-td {
    background-color: #98aab9;
  }
.t-tfoot {
  background: #fff;
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
.s-bak-td {
  background-color: #e0e6ea;
  border:0 solid @bak-color-main;
}
.jj-bak-td {
  background-color: @bak-color-2;
  color: #00ccff;
}
.ps-bak-td {
  background-color: #98aab9;
}
table {
  border-spacing: 0px;
  width: 100%;
  th {
    border:0.2px solid @bak-color-main;
    text-align: center;
    font-size: 0.8em;
    line-height: 2.5em;
    color: @bak-color-1;
    font-weight: 100;
  }
  td {
    border:0.2px solid @bak-color-main;
    text-align: center;
    font-size: 0.8em;
    line-height: 2.5em;
    color: @bak-color-1;
  }
}
.scroll-table {
    display:block;
    max-height: 22rem;
    overflow-y:auto;
}

</style>



// WEBPACK FOOTER //
// MiiBaseTable2.vue?785dff1c